import { type FunctionalComponent, h } from '@stencil/core';
import { showMedaliaComponent } from '../../../../../utils/medalia-integration/medalia-integration';
import { medaliaGenAiConfigurationObject } from '../../../../../utils/medalia-integration/medalia-configurations';
import { eventDispatcherForFunctionalComponents } from '../../conversational-search-logic/utils/utils';
import { ConversationalSearchLabelWithSection } from '../label-with-section/label-with-section';
import EventEmitterComponent from '../event-emitter-component/event-emitter-component';

export interface IConversationalSearchFeedback {
  conversationalSearchMedaliaFormId: string;
  query: string;
  country: string;
  language: string;
  text: string;
  boldedPartText?: string;
  ctaText?: string;
  bannerVariant?: boolean;
}

export const ConversationalSearchFeedback: FunctionalComponent<
  IConversationalSearchFeedback
> = (props) => {
    const { conversationalSearchMedaliaFormId, query, country, language } = props;
    const ctaName = props.bannerVariant ? 'Feedback From Banner' : 'Feedback';
    const eventBannerSuffix = props.bannerVariant ? '-banner' : '';
    const medaliafallback = () => eventDispatcherForFunctionalComponents(`conversational-search:medalia-fallback${eventBannerSuffix}`);
    const onClickAction = () => {
        showMedaliaComponent(
          conversationalSearchMedaliaFormId,
          medaliaGenAiConfigurationObject(country, language),
          medaliafallback
        );
    };

    return (
      <div class={{'conversational-search-feedback': true, 'conversational-search-feedback--banner': props.bannerVariant}}>
        <ConversationalSearchLabelWithSection text={props.text} partial={props.boldedPartText}>
          <EventEmitterComponent
            eventName='conversational-search:ga-cta'
            isNotPropagatedForEnter={true}
            ctaName={ctaName}
            keyword={query}
          >
            <qds-inline-link
              onClick={() => onClickAction()}
              onKeyDown={(e) => e.key === 'Enter' ? onClickAction() : void 0}
            >
              {props.ctaText}
            </qds-inline-link>
          </EventEmitterComponent>
        </ConversationalSearchLabelWithSection>
      </div>
    );
};
